import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAdminMe, useAdminLogout } from "../hooks/useApi";

interface MenuItem {
  to: string;
  label: string;
  permission?: string;
  icon: React.ReactNode;
}

const restTabs: MenuItem[] = [
  {
    to: "/admin/notifications",
    label: "اعلان‌ها",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 01-3.46 0" />
      </svg>
    ),
  },
  {
    to: "/admin/partners",
    label: "شرکا",
    permission: "partners.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="m11 17 2 2a1 1 0 1 0 3-3" />
        <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
        <path d="m21 3 1 11h-2" />
        <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
        <path d="M3 4h8" />
      </svg>
    ),
  },
  {
    to: "/admin/models",
    label: "مدل‌ها",
    permission: "models.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a10 10 0 1010 10" />
        <path d="M12 12l3-3" />
        <circle cx="12" cy="12" r="2" />
        <path d="M21 2l-4 4" />
        <path d="M21 2h-4" />
        <path d="M21 6V2" />
      </svg>
    ),
  },
  {
    to: "/admin/roles",
    label: "نقش‌ها",
    permission: "roles.manage",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l3 2.5H17l1 2.5 2 1.5v3l-2 1.5-1 2.5h-2L12 18l-3-2.5H7l-1-2.5-2-1.5v-3l2-1.5 1-2.5h2z" />
        <path d="M12 8l.9 2 2 .9-2 .9-.9 2-.9-2-2-.9 2-.9z" />
      </svg>
    ),
  },
  {
    to: "/admin/plans",
    label: "اشتراک‌ها",
    permission: "subscriptions.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
      </svg>
    ),
  },
  {
    to: "/admin/logs",
    label: "لاگ‌ها",
    permission: "logs.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    to: "/admin/expenses",
    label: "هزینه‌ها",
    permission: "expenses.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
      </svg>
    ),
  },
  {
    to: "/admin/factors",
    label: "فاکتورها",
    permission: "factors.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    to: "/admin/settings",
    label: "تنظیمات",
    permission: "settings.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
      </svg>
    ),
  },
  {
    to: "/admin/messages",
    label: "اطلاع‌رسانی‌ها",
    permission: "messages.view",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 11l8-5v12l-8-5z" />
        <path d="M11 9h4a2 2 0 012 2v2a2 2 0 01-2 2h-4" />
        <path d="M17 9a4 4 0 010 6" />
        <path d="M19 7a6 6 0 010 10" />
      </svg>
    ),
  },
];

interface AdminMobileHeaderProps {
  permissions?: string[];
  isAdmin?: boolean;
}

export default function AdminMobileHeader({ permissions = [], isAdmin = false }: AdminMobileHeaderProps) {
  const { data: user } = useAdminMe();
  const logout = useAdminLogout();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const has = (permission?: string) =>
    isAdmin || (permission ? permissions.includes(permission) : true);

  const visible = restTabs.filter((item) => has(item.permission));

  const homeHref = has("stats.view")
    ? "/admin/dashboard"
    : visible.length > 0
    ? visible[0].to
    : "/admin/tickets";

  const roleLabel = user?.is_admin
    ? "مدیر سیستم"
    : (user?.roles || []).map((r: { display_name: string }) => r.display_name).join("، ") || "کاربر سیستم";

  const initials = (user?.name || user?.email || "A")
    .charAt(0)
    .toUpperCase();

  return (
    <header
      className="lg:hidden sticky top-0 z-40"
      style={{ background: "var(--admin-bg-surface)", borderBottom: "1px solid var(--admin-border)" }}
    >
      <div className="flex flex-row-reverse items-center justify-between gap-3 px-4 py-3">
        {/* Logo */}
        <a href="/admin/dashboard" className="flex flex-row-reverse items-center gap-2 shrink-0">
          <img src="/admin-logo-reverse-filled.svg" alt="پنل ادمین" className="w-8 h-8" />
          <span className="font-bold text-lg" style={{ color: "var(--admin-text-primary)" }}>پنل ادمین</span>
        </a>

        {/* User area */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex items-center gap-2 rounded-xl px-2 py-1.5 transition-all cursor-pointer"
            style={{
              background: open ? "var(--admin-bg-hover)" : "transparent",
              border: `1px solid ${open ? "var(--admin-border)" : "transparent"}`,
            }}
          >
            <div
              className="w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-semibold shrink-0"
              style={{ background: "var(--admin-primary)" }}
            >
              {initials}
            </div>
            <span className="text-sm font-medium hidden min-[380px]:block" style={{ color: "var(--admin-text-primary)" }}>
              {user?.name || "مدیر"}
            </span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ color: "var(--admin-text-tertiary)" }}>
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          {/* Glass dropdown */}
          {open && (
            <div className="absolute right-0 top-full mt-2 w-56 admin-glass rounded-2xl overflow-hidden z-50 animate-drawer">
              <div className="p-3 border-b" style={{ borderColor: "var(--admin-border)" }}>
                <p className="text-sm font-medium truncate" style={{ color: "var(--admin-text-primary)" }}>{user?.name || user?.email}</p>
                <p className="text-xs truncate" style={{ color: "var(--admin-text-tertiary)" }}>{roleLabel}</p>
              </div>
              <div className="p-1">
                {visible.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm transition-colors"
                    style={({ isActive }) => ({
                      color: isActive ? "var(--admin-primary)" : "var(--admin-text-secondary)",
                      background: isActive ? "rgba(7,135,131,0.08)" : undefined,
                    })}
                  >
                    <span className="shrink-0">{item.icon}</span>
                    {item.label}
                  </NavLink>
                ))}
              </div>
              <div className="p-1 border-t" style={{ borderColor: "var(--admin-border)" }}>
                <button
                  onClick={() => {
                    setOpen(false);
                    logout.mutate();
                  }}
                  className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm transition-colors w-full cursor-pointer"
                  style={{ color: "var(--admin-error)" }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  خروج
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
